import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import store from './../store'
import axios from 'axios'
import HomeView from '@/views/HomeView.vue'
import ParametresPharmaciePage from '@/views/ParametresPharmaciePage.vue'
import LoginView from '@/views/auth/LoginView.vue'
import NewPasswordView from '@/views/auth/NewPasswordView.vue'
import IndexUtilisateur from '@/views/admin/utilisateurs/IndexUtilisateur.vue'
import ActiviteUtilisateur from '@/views/admin/utilisateurs/ActiviteUtilisateur.vue'
import IndexProduit from '@/views/stock/produits/IndexProduit.vue'
import IndexCommande from '@/views/stock/commandes/IndexCommande.vue'
import IndexFournisseurs from '@/views/stock/fournisseurs/IndexFournisseur.vue'
import IndexBdd from '@/views/stock/bases_de_donnees/IndexBdd.vue'
import IndexRayon from '@/views/stock/rayons/IndexRayon.vue'
import IndexMouvement from '@/views/stock/mouvement/IndexMouvement.vue'
import IndexCaisse from '@/views/vente/caisse/IndexCaisse.vue'
import IndexClient from '@/views/vente/client/IndexClient.vue'
import IndexDevis from '@/views/vente/devis/IndexDevis.vue'
import IndexVente from '@/views/vente/ventes/IndexVente.vue'
import IndexConfiguration from '@/views/vente/configuration/IndexConfiguration.vue'
import IndexBilletage from '@/views/gestion/billetages/IndexBilletage.vue'
import IndexJournees from '@/views/gestion/journees/IndexJournees.vue'
import IndexGarde from '@/views/gestion/gardes/IndexGarde.vue'
import IndexInventaire from '@/views/gestion/inventaires/IndexInventaire.vue'
import IndexParametre from '@/views/admin/parametres/IndexParametre.vue'
import IndexReservations from '@/views/vente/reservations/IndexReservation.vue'
import IndexStatistique from '@/views/gestion/statistiques/IndexStatistique.vue'
import ShowReservationCaisse from '@/views/vente/caisse/ShowReservationCaisse.vue'
import ActivationView from '@/views/auth/VerificationApplication.vue'
import IndexRetour from '@/views/stock/retours/IndexRetour.vue'

interface ActivationState {
  token?: string;
  date_activation?: string;
  type?: string;
  expires_at?: string | null;
}
const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/login',
    name: 'login',
    component: LoginView,
    meta: {
      noHeader: true,
      noFooter: true
    }
  },
  {
    path: '/new-password',
    name: 'new.password',
    component: NewPasswordView
  },
  {
    path: '/admin/utilisateurs',
    name: 'utilisateurs',
    component: IndexUtilisateur,
    meta: { menuModule: 'admin', sousMenu: ['utilisateur'] }
  },
  {
    path: '/admin/activites-recentes',
    name: 'activity_logs',
    component: ActiviteUtilisateur,
    meta: { menuModule: 'admin', sousMenu: ['utilisateur'] }
  },
  {
    path: '/stock/produits',
    name: 'produit',
    component: IndexProduit,
    meta: { menuModule: 'stock', sousMenu: ['produit'] }
  },
   {
    path: '/stock/commandes',
    name:'commande',
    component:IndexCommande,
    meta: { menuModule: 'stock', sousMenu: ['commande'] }
  },
  {
    path : '/stock/fournisseurs',
    name:'fournisseurs',
    component:IndexFournisseurs,
    meta: { menuModule: 'stock', sousMenu: ['fournisseur'] }
  },
  {
    path : '/stock/retour-fournisseur',
    name:'retour-fournisseur',
    component:IndexRetour,
    meta: { menuModule: 'stock', sousMenu: ['retour'] }
  },
  {
    path:'/stock/database',
    name:'database',
    component:IndexBdd,
    meta: { menuModule: 'stock', sousMenu: ['base'] }
  },
  {
    path:'/stock/rayon',
    name:'rayon',
    component:IndexRayon,
    meta: { menuModule: 'stock', sousMenu: ['rayon'] }
  },
  {
    path:'/stock/mouvement',
    name:'mouvement',
    component:IndexMouvement,
    meta: { menuModule: 'stock', sousMenu: ['mouvement'] }
  },
  {
    path:'/vente/caisses',
    name:'caisse',
    component:IndexCaisse,
    meta: { menuModule: 'vente', sousMenu: ['caisse'] }
  },
  {
    path:'/vente/caisses/reservation/:id',
    name:'caisse.reservation',
    props: true,
    component:ShowReservationCaisse,
    meta: { menuModule: 'vente', sousMenu: ['caisse'] }
  },
  {
    path:'/vente/clients',
    name:'client',
    component:IndexClient,
    meta: { menuModule: 'vente', sousMenu: ['client'] }
  },
  {
    path:'/vente/devis',
    name:'devis',
    component:IndexDevis,
    meta: { menuModule: 'vente', sousMenu: ['devis'] }
  },
  {
    path:'/vente/dashboard',
    name:'dashboard',
    component:IndexVente,
    meta: { menuModule: 'vente', sousMenu: ['vente'] }
  },
  {
    path:'/vente/configuration',
    name:'configuration',
    component:IndexConfiguration,
    meta: { menuModule: 'vente', sousMenu: ['configuration'] }
  },
  {
    path:'/gestion/arrete-caisse',
    name:'arrete-caisse',
    component:IndexBilletage,
    meta: { menuModule: 'gestion', sousMenu: ['caisse'] }
  },
  {
    path:'/gestion/fin-journee',
    name:'fin-journee',
    component:IndexJournees,
    meta: { menuModule: 'gestion', sousMenu: ['journee'] }
  },
  {
    path:'/gestion/garde',
    name:'garde',
    component:IndexGarde,
    meta: { menuModule: 'gestion', sousMenu: ['garde'] }
  },
  {
    path:'/gestion/inventaire',
    name:'inventaire',
    component:IndexInventaire,
    meta: { menuModule: 'gestion', sousMenu: ['inventaire'] }
   },
  {
    path:'/admin/parametres',
    name:'parametres',
    component:IndexParametre,
    meta: { menuModule: 'gestion', sousMenu: ['parametre'] }
  },
  {
    path:'/parametrage',
    name:'parametrage',
    component:ParametresPharmaciePage,
    meta: { menuModule: 'gestion', sousMenu: ['parametre'] }
  },
  {
    path:'/vente/reservation',
    name:'reservation',
    component:IndexReservations,
    meta: { menuModule: 'gestion', sousMenu: ['reservation'] }
  },
  {
    path:'/gestion/statistique',
    name:'statistique',
    component:IndexStatistique,
    meta: { menuModule: 'gestion', sousMenu: ['stat'] }
  },
  {
    path: '/activation',
    name: 'activation',
    component: ActivationView, // remplacez ActivationView par le composant correspondant
    meta: {
      noHeader: true,
      noFooter: true
    }
  },
  {
    // Catch-all: toute route inconnue renvoie vers l’accueil
    path: '/:pathMatch(.*)*',
    redirect: { name: 'home' },
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

const ACTIVATION_STORAGE_KEY = 'activationData';

// Fonctions helpers avec typage explicite
function getActivationData(): ActivationState | null {
  try {
    const data = localStorage.getItem(ACTIVATION_STORAGE_KEY);
    if (!data) return null;
    
    const parsed = JSON.parse(data) as ActivationState;
    return parsed.token && parsed.date_activation ? parsed : null;
  } catch {
    return null;
  }
}

function checkActivation(data: ActivationState | null): data is ActivationState {
  return !!data?.token?.trim() && !!data?.date_activation?.trim();
}

function cacheActivationData(activation: ActivationState): void {
  window.localStorage.setItem(ACTIVATION_STORAGE_KEY, JSON.stringify(activation));
}

function normalizeServerActivation(rawActivation: any): ActivationState | null {
  if (!rawActivation) return null;

  const activation = {
    token: String(rawActivation.token || '').trim(),
    date_activation: String(rawActivation.date_activation || '').trim(),
    type: rawActivation.type || 'serveur',
    expires_at: rawActivation.expires_at || null,
  };

  return checkActivation(activation) ? activation : null;
}

async function resolveServerActivation(): Promise<boolean> {
  try {
    const response = await axios.get('/api/activation/status');
    const data = response.data?.data;

    if (data?.pharmacie) {
      store.commit('setPharmacieDatas', data.pharmacie);
    }

    if (data?.activated) {
      const activation = normalizeServerActivation(data.activation);

      if (activation) {
        cacheActivationData(activation);
        return true;
      }
    }
  } catch (error) {
    console.warn('Impossible de vérifier l’activation serveur:', error);
  }

  return false;
}

// router.beforeEach((to, from, next) => {
//   // 1. Vérification de l'activation
//   const activationData = getActivationData();
//   const isActivated = checkActivation(activationData);

//   // 2. Gestion de la page d'activation
//   if (!isActivated) {
//     return to.name === 'activation' ? next() : next({ name: 'activation' });
//   }

//   // 3. Empêcher l'accès à l'activation si déjà activé
//   if (to.name === 'activation') {
//     return next({ name: 'home' });
//   }

//   // 4. Vérification de l'authentification
//   if (!store.getters.authenticated) {
//     return to.name === 'login' ? next() : next({ name: 'login' });
//   }

  
  
//   // 5. Vérification du changement de mot de passe
//   if (store.getters.user.must_change_password) {
//     return to.name === 'new.password' ? next() : next({ name: 'new.password' });
//   }
//   // 6. redirection vers la page home si l'user est connecté et l'application est activé
//   if (store.getters.authenticated && isActivated) {
//     if (to.name === 'login' || to.name === 'activation') {
//       return next({ name: 'home' });
//     }
//   }
//   // 6. Autoriser l'accès
//   next();
// });
// // Ajouter à la fin du router
// router.afterEach((to) => {
//   if (!to.matched.length) {
//     router.replace('/');
//   }
// });








// Routes accessibles sans être authentifié
const publicRouteNames = new Set<string>(['login', 'activation']);

// 🧠 Garde globale : Activation + Auth + Mot de passe
router.beforeEach(async (to, from, next) => {
  // 1️⃣ Vérification de l’activation (comme dans ton ancien projet)
  const activationData = getActivationData();      // ex: lit localStorage / fichier de config
  let isActivated = checkActivation(activationData); // renvoie true/false

  if (!isActivated) {
    isActivated = await resolveServerActivation();
  }

  // ⛔ Application non activée → on force vers la page d’activation
  if (!isActivated) {
    // On laisse passer uniquement la page d’activation (et éventuellement login si tu le veux)
    if (to.name !== 'activation') {
      return next({ name: 'activation' });
    }
    // Si déjà sur /activation, on laisse passer
    return next();
  }

  // ✅ Application déjà activée → on empêche l’accès à la page d’activation
  if (isActivated && to.name === 'activation') {
    return next({ name: 'home' });
  }

  // 2️⃣ Vérification de l’authentification
  const isAuthenticated = store.getters.authenticated;
  const user = store.getters.user || {};
  const mustChangePassword = !!user.must_change_password;

  const goingToPublicRoute = to.name
    ? publicRouteNames.has(String(to.name))
    : false;

  // Utilisateur NON connecté → accès limité aux routes publiques et à new.password
  if (!isAuthenticated && !goingToPublicRoute && to.name !== 'new.password') {
    return next({ name: 'login' });
  }

  // Utilisateur connecté qui doit changer son mot de passe
  if (isAuthenticated && mustChangePassword && to.name !== 'new.password') {
    return next({ name: 'new.password' });
  }

  // Utilisateur connecté → inutile de voir login/activation
  if (isAuthenticated && (to.name === 'login' || to.name === 'activation')) {
    return next({ name: 'home' });
  }

  // ✅ Sinon, on laisse passer
  return next();
});

export default router
